import type { AxiosError, AxiosResponse } from 'axios';
import axios from 'axios';
import toast from 'react-hot-toast';

import { getConfig } from '@zoomit/configs';

import { responseMessages } from '../constants/response-messages';

export const ApiManager = axios.create({
  baseURL: getConfig('API_BASE_URL'),
});
export const SHOW_TOAST_HEADER = 'showToast';

ApiManager.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const { response } = error;
    if (response?.config.headers[SHOW_TOAST_HEADER] === false) {
      return Promise.reject(error);
    }

    if (response && response?.config.method !== 'get') {
      const message =
        (response && responseMessages[response.status as keyof typeof responseMessages]?.fa) ||
        responseMessages.failed.fa;
      toast.error(message);
    }

    return Promise.reject(error);
  },
);
